import { PositionPriceTrailLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/PositionPriceTrailLine';
import { PositionPriceTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/PositionPriceTrailTacticPanel';
import { AddPositionPriceTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddPositionPriceTrail';
import { PositionPriceTrailWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/PositionPriceTrailModule/wrapper/PositionPriceTrailWrapper';
import PositionPriceTrailDocs from '../../../../components/forms/tradeplans/documentation/PositionPriceTrailDocumentation';
import PositionPriceTrailModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/PositionPriceTrailModule';
import { PositionPriceTrailData } from './positionPriceTrailData';
import { validatePositionPriceTrail } from './validatePositionPriceTrail';

export const PositionPriceTrail = {
  //data class
  dataStore: PositionPriceTrailData,

  //string constants
  name: 'POSITION_PRICE_TRAIL',
  tacticLabel: 'Position Price Trail',
  addTacticLabel: 'Add Position Price Trail',
  category: 'Exit',

  // components
  tradePlanFormModule: PositionPriceTrailModule,
  tacticPanel: PositionPriceTrailTacticPanel,
  addTacticPanel: AddPositionPriceTrailTacticPanel,
  wrapper: PositionPriceTrailWrapper,
  chartSoftOrderComponent: PositionPriceTrailLine,
  documentation: PositionPriceTrailDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validatePositionPriceTrail,
};
